// const APIBaseURL = 'http://192.168.0.139:3001/v0/';

const APIBaseURL = 'https://printlificapi.printlific.com/v0/';
// const APIBaseURL = 'http://localhost:3001/v0/';
// const APIBaseURL = 'https://beta.printlific.com/v0/';
// const ImageURL = 'https://printlific.s3.us-east-2.amazonaws.com/' 
const ImageURL = ''

export { APIBaseURL, ImageURL }